export default {
    _eventNS() {
        if(this._eventNSMap) {
            return this._eventNSMap;
        } else {
            const m = new Map();
            this._eventNSMap = m;
            return m;
        }
    },

    bindWithNamespace(namespace, event, handler) {
        let ns = this._eventNS().get(namespace);
        if(!ns) {
            ns = [];
            this._eventNS().set(namespace, ns);
        }
        ns.push({event, handler});
        this.bind(event, handler);
    },

    unbindNamespace(namespace) {
        let ns = this._eventNS().get(namespace);
        if(ns) {
            this._eventNS().delete(namespace);
            ns.forEach(({event, handler}) => {
                this.unbind(event, handler);
            });
        }
    },
}
